import React, { Fragment, useEffect } from "react";

import Hero from "../components/Hero";
import Highlight from "../components/Highlight";
import Content from "../components/Content";
import { useAuth0 } from "@auth0/auth0-react";

export const Home = () => {
  const { user, isAuthenticated, getIdTokenClaims, getAccessTokenSilently } = useAuth0();

  let at, claims

  useEffect(async () => {
    at = await getAccessTokenSilently();
    claims = await getIdTokenClaims()
  }, [isAuthenticated])


  return (
    <Fragment>
      {
        isAuthenticated && (
        <Highlight>{at}</Highlight>
        )
      }
      {
        !isAuthenticated && (
          <>
            <Hero />
            <hr />
            <Content />
          </>
        )
      }
    </Fragment>

  );
};

export default Home;
